import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Topbar from '../components/Topbar';
import Sidebar from '../components/Sidebar';
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import axios from "axios";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Modal } from 'antd';
import { currency } from '../../../dynamicController';

const mySwal = withReactContent(Swal);

const TaskDetails = ({ token, staff }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    const [toggled, setToggled] = useState(false);
    const [taskList, setTaskList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [chargeModal, setChargeModal] = useState(false)
    const [confirmModal, setConfirmModal] = useState(false)
    const [description, setDescription] = useState("")
    const [chargeAmount, setChargeAmount] = useState(0)
    const [selectedTaskId, setSelectedTaskId] = useState(null)
    const [deleteConfirmModal, setDeleteConfirmModal] = useState(false)

    useEffect(() => {
        if (!location.state) {
            history.push("/staff")
        } else {
            setTaskList(location.state.taskList)
        }
    }, []);

    const handleToggle = () => {
        setToggled(!toggled);
    }

    const collect = () => {
        mySwal.fire({
            title: t("Confirmation"),
            text: t("Are you sure the customer have collected the laundry?"),
            icon: "question",
            showCancelButton: true,
            cancelButtonText: t("No"),
            confirmButtonText: t("Yes"),
            customClass: {
                confirmButton: 'collect-yes',
                cancelButton: 'collect-no'
            },
        })
            .then(click => {
                if (click.isConfirmed && click.value) {
                    setLoading(true)
                    axios
                        .post("/api/user/dng/collected", { id: taskList[0].pack_number, role: "staff", token })
                        .then(res => {
                            setLoading(false)
                            history.push("/staff")
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                }
            })
    }

    const printSticker = () => {
        mySwal.fire({
            title: t("Confirmation"),
            text: t("Are you sure you want to print sticker?"),
            icon: "question",
            showCancelButton: true,
            cancelButtonText: t("No"),
            confirmButtonText: t("Yes"),
            customClass: {
                confirmButton: 'print-sticker-yes',
                cancelButton: 'print-sticker-no'
            },
        })
            .then(click => {
                if (click.isConfirmed && click.value) {
                    setLoading(true)
                    axios.post('/api/staff/printer/print/sticker', { sequenceId: taskList[0].pack_number }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setLoading(false)
                            mySwal.fire(t("Success"), t("Printer added print task successfully!"), "success");
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        });
                }
            })
    }

    const handleAddChargeButton = () => {
        setChargeModal(true)
        setDescription("")
        setChargeAmount(0)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setConfirmModal(true)
    }

    const addCharges = () => {
        setConfirmModal(false)
        setLoading(true)

        let sendThis = {
            sequenceId: taskList[0].pack_number,
            description,
            chargeAmount,
            size: taskList[0].size
        }

        axios.post('/api/staff/addCharge', sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setLoading(false)
                setChargeModal(false)
                mySwal.fire(t("Success"), t("Charges added successfully!"), "success");
                history.push('/staff/dashboard')
            })
            .catch(err => {
                setLoading(false)
                setChargeModal(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
            })
    }

    const handleEditButton = (taskId, chargeDescription, price) => {
        setSelectedTaskId(taskId)
        setDescription(chargeDescription)
        setChargeAmount(price)
        setChargeModal(true)
    }

    const editCharges = () => {
        setConfirmModal(false)
        setLoading(true)

        let sendThis = {
            taskId: selectedTaskId,
            description,
            chargeAmount,
        }

        axios.post('/api/staff/editCharge', sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setLoading(false)
                setChargeModal(false)
                setSelectedTaskId(null)
                mySwal.fire(t("Success"), t("Charges edited successfully!"), "success");
                history.push('/staff/dashboard')
            })
            .catch(err => {
                setLoading(false)
                setChargeModal(false)
                setSelectedTaskId(null)
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
            })
    }

    const handleDeleteButton = (taskId, chargeDescription, price) => {
        setSelectedTaskId(taskId)
        setDescription(chargeDescription)
        setChargeAmount(price)
        setDeleteConfirmModal(true)
    }

    const deleteCharges = () => {
        setLoading(true)

        axios.post('/api/staff/deleteCharge', { taskId: selectedTaskId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setLoading(false)
                setDeleteConfirmModal(false)
                setSelectedTaskId(null)
                mySwal.fire(t("Success"), t("Charges deleted successfully!"), "success");
                history.push('/staff/dashboard')
            })
            .catch(err => {
                setLoading(false)
                setDeleteConfirmModal(false)
                setSelectedTaskId(null)
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
            })
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />

            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />

                <div className="admin-content">
                    <div className="d-flex justify-content-between">
                        <div className="mb-3 d-flex" onClick={e => history.push('/staff/dashboard')}>
                            <i className="bi bi-chevron-left"></i>
                            <p className="ps-2">{t("Back")}</p>
                        </div>
                        <div className='d-flex'>
                            {
                                loading ? (
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                ) : <button className="btn btn-primary" type="button" onClick={() => handleAddChargeButton()}>{t("Add Charges")}</button>
                            }
                            {
                                staff.cash ? (
                                    <div>
                                        {
                                            loading ? (
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            ) : (
                                                <button className="btn btn-primary ms-3" type="button" onClick={() => printSticker()}>{t("Print Sticker")}</button>
                                            )
                                        }
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                    {
                        taskList.length > 0 ? (
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title">{t("Pack Number")} {taskList[0].pack_number}</h5>
                                </div>

                                <div className="card-body">
                                    <p>{t("Order Date")}: {taskList[0].date}</p>
                                    <p>{t("Outlet")}: {taskList[0].outlet_fullname} ({taskList[0].outlet_name})</p>
                                    <p>{t("Size")}: {taskList[0].size}</p>
                                    {taskList[0].collect_time ? <p>{t("Collect Time")}: {taskList[0].collect_time}</p> : null}
                                    {taskList[0].member_id ? <p>{t("Member ID")}: {taskList[0].member_id}</p> : null}
                                    {taskList[0].username ? <p>{t("Name")}: {taskList[0].username}</p> : null}
                                    {taskList[0].email ? <p>{t("Email")}: {taskList[0].email}</p> : null}
                                    {taskList[0].number ? <p>{t("Phone Number")}: {taskList[0].number}</p> : null}
                                </div>
                            </div>
                        ) : null
                    }

                    {
                        taskList.map((task, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="card-header d-flex justify-content-between">
                                        <h5 className="card-title">{t(task.name)}</h5>
                                        {
                                            task.name === "Charge" ? (
                                                <div className='d-flex'>
                                                    <div className='text-center pe-3'>
                                                        <button className="btn btn-primary" type="button" onClick={() => handleEditButton(task.id, task.mode, task.price)}>{t("Edit")}</button>
                                                    </div>

                                                    <div className='text-center'>
                                                        <button className="btn btn-danger" type="button" onClick={() => handleDeleteButton(task.id, task.mode, task.price)}>{t("Delete")}</button>
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                    </div>

                                    <div className="card-body">
                                        <p>{t("Task ID")}: {task.id}</p>
                                        {task.capacity ? <p>{t("Capacity")}: {task.capacity}</p> : null}
                                        {task.mode ? <p>{task.name === "Wash" ? t("Mode") : task.name === "Charge" ? t("Description") : t("Accessory")}: {t(task.mode)}</p> : null}
                                        {task.machine_duration ? <p>{t("Duration")}: {task.machine_duration} {t("min")}</p> : null}
                                        {task.machine ? <p>{t("Machine")}: {task.machine}</p> : null}
                                        {task.status && task.name !== "Charge" ? <p style={{ color: task.status === "Completed" ? "green" : "#FF3C00" }}>{t("Status")}: {t(task.status)}</p> : null}
                                        {task.name === "Accessory" ? <p>{t("Quantity")}: {task.quantity}</p> : null}
                                        {task.name === "Charge" ? <p>{t("Price")}: {currency(staff.country)} {task.price}</p> : null}

                                        {task.status !== "Completed" ? (
                                            <div className='text-center'>
                                                <button className="btn btn-primary" type="button" onClick={() => history.push('/staff/task/start', { task })}>{t("Start Task")}</button>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            )
                        })
                    }

                    {
                        taskList.length > 0 && !taskList[0].collect_time && taskList.filter(task => task.status !== "Completed").length <= 0 ? (
                            <div className='text-center'>
                                {
                                    loading ? (
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    ) : (
                                        <button className="btn btn-primary" type="button" onClick={() => collect()}>{t("Collected")}</button>
                                    )
                                }
                            </div>
                        ) : null
                    }
                </div>
            </div>

            <Modal
                open={chargeModal}
                onCancel={() => setChargeModal(false)}
                footer={null}
                centered
                title={selectedTaskId ? t("Edit Charges") : t("Add Charges")}
            >
                <div>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group text-left">
                            <label htmlFor="description">{t("Description")}</label>
                            <input type="text" id="description" name="description" value={description} className="form-control browser-default" onChange={e => setDescription(e.target.value)} required />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="chargeAmount">{t("Charges Amount")}</label>
                            <input type="number" min={0.01} step="0.01" id="chargeAmount" name="chargeAmount" value={chargeAmount} className="form-control browser-default" onChange={e => setChargeAmount(e.target.value)} required />
                        </div>

                        <div className="text-center pt-3">
                            <button type="submit" className="btn btn-secondary me-3">
                                {selectedTaskId ? t("Edit Charges") : t("Add Charges")}
                            </button>
                            <button type="button" className="btn btn-danger" onClick={() => setChargeModal(false)}>
                                {t("Close")}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>

            <Modal
                open={confirmModal}
                onCancel={() => setConfirmModal(false)}
                footer={null}
                centered
                title={t("Confirmation")}
            >
                <div>
                    <p>{selectedTaskId ? t("Are you sure you want to edit this charges") : t("Are you sure you want to add this charges?")}</p>
                    <div className="text-center pt-3">
                        <button type="button" className="btn btn-secondary me-3" onClick={() => { selectedTaskId ? editCharges() : addCharges() }}>
                            {t("Confirm")}
                        </button>
                        <button type="button" className="btn btn-danger" onClick={() => setConfirmModal(false)}>
                            {t("Cancel")}
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                open={deleteConfirmModal}
                onCancel={() => setDeleteConfirmModal(false)}
                footer={null}
                centered
                title={t("Confirmation")}
            >
                <div>
                    <p>{t("Are you sure you want to delete this charges?")}</p>
                    <p><b>{description} ({currency(staff.country)}{chargeAmount})</b></p>
                    {
                        loading ? (
                            <div className="text-center">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center pt-3">
                                <button type="button" className="btn btn-secondary me-3" onClick={deleteCharges}>
                                    {t("Confirm")}
                                </button>
                                <button type="button" className="btn btn-danger" onClick={() => setDeleteConfirmModal(false)}>
                                    {t("Cancel")}
                                </button>
                            </div>
                        )
                    }
                </div>
            </Modal>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        staff: state.staff.staff,
        token: state.staff.token,
    };
};

export default connect(mapStateToProps, null)(TaskDetails); 
